
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Game } from "@/types/game";
import { GameFormFields } from "./dialog/GameFormFields";
import { GameFormActions } from "./dialog/GameFormActions";
import { useGameForm } from "./dialog/useGameForm";

interface AddEditGameDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isEditMode: boolean;
  currentGame: Game | null;
  onGameSaved: () => void;
}

export const AddEditGameDialog: React.FC<AddEditGameDialogProps> = ({
  isOpen,
  setIsOpen,
  isEditMode,
  currentGame,
  onGameSaved,
}) => {
  const {
    gameName,
    setGameName,
    coverUrl,
    previewUrl,
    setCoverFile,
    setPreviewUrl,
    uploading,
    handleSubmit
  } = useGameForm({
    isOpen,
    setIsOpen,
    isEditMode,
    currentGame,
    onGameSaved
  });

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()} modal>
      <DialogContent 
        className="bg-[#181D24] text-white border-[#222A35] shadow-xl max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#00B6F0] to-[#5fceff]">
            {isEditMode ? "Editar Jogo" : "Adicionar Novo Jogo"}
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            {isEditMode 
              ? "Modifique os detalhes do jogo abaixo." 
              : "Preencha os detalhes do novo jogo abaixo."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6">
          <GameFormFields 
            gameName={gameName}
            previewUrl={previewUrl}
            isEditMode={isEditMode}
            currentGameCoverUrl={currentGame?.cover_url || null}
            disabled={uploading}
            onNameChange={setGameName}
            onFileChange={setCoverFile}
            onPreviewChange={setPreviewUrl}
          />
          
          <GameFormActions 
            isUploading={uploading}
            isEditMode={isEditMode}
            onCancel={() => setIsOpen(false)}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
};
